import { useNavigate, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';

/** The search param of the proposal drawer, open over any screen of the app (spec 030). */
export const PROPOSAL_SEARCH_PARAM = 'proposal';

type Search = Record<string, unknown>;

/**
 * The proposal drawer, driven by the URL (`?proposal=<id>`), like the settings window: a link
 * opens it over the screen it points to, the back button closes it.
 */
export function useProposalLink() {
  const search = useSearch({ strict: false }) as Search;
  const navigate = useNavigate();
  const value =
    typeof search[PROPOSAL_SEARCH_PARAM] === 'string'
      ? (search[PROPOSAL_SEARCH_PARAM] as string)
      : undefined;

  const open = useCallback(
    (id: string) =>
      void navigate({
        to: '.',
        search: (prev: Search) => ({ ...prev, [PROPOSAL_SEARCH_PARAM]: id }),
      } as never),
    [navigate],
  );
  const close = useCallback(
    () =>
      void navigate({
        to: '.',
        search: (prev: Search) => {
          const next = { ...prev };
          delete next[PROPOSAL_SEARCH_PARAM];
          return next;
        },
      } as never),
    [navigate],
  );
  return { value, open, close };
}
